<div class="grafico-barra">
  <p-chart
    type="bar"
    [data]="chartData()"
    [options]="options()"
    [plugins]="barPlugins()"
    [style]="{ height: '100%', width: '100%' }"
  />
</div>
